import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.users.components';

export default defineMessages({
    save: {
        id: `${scope}.label.save`,
        defaultMessage: 'Save',
    },
    addUserLabel: {
        id: `${scope}.label.addUser`,
        defaultMessage: 'Add user',
    },
    editUserLabel: {
        id: `${scope}.label.editUser`,
        defaultMessage: 'Edit user',
    },
    deleteUserLabel: {
        id: `${scope}.label.deleteUser`,
        defaultMessage: 'Delete user',
    },
    nameColumnLabel: {
        id: `${scope}.grid.column.name`,
        defaultMessage: 'Name',
    },
    usernameColumnLabel: {
        id: `${scope}.grid.column.username`,
        defaultMessage: 'Username',
    },
    emailColumnLabel: {
        id: `${scope}.grid.column.email`,
        defaultMessage: 'Email',
    },
    rolesColumnLabel: {
        id: `${scope}.grid.column.roles`,
        defaultMessage: 'Roles',
    },
    unknownRoleNameTooltip: {
        id: `${scope}.tooltip.unknownRoleName`,
        defaultMessage: 'Unknown role name for id {id}',
    },
});